import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { ChevronLeft, ChevronRight, Tag, X, Calendar } from "lucide-react";

const OffersPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Array of offer images
  const offerImages = [
    {
      src: "/images/1.png",
      alt: "Offer 1 - PetShop Special",
    },
    {
      src: "/images/2.png",
      alt: "Offer 2 - Essentials",
    },
    {
      src: "/images/3.png",
      alt: "Offer 3 - Grooming",
    },
    {
      src: "/images/4.png",
      alt: "Offer 4 - Grooming",
    },
  ];

  const handlePrevious = () => {
    setCurrentImageIndex((prev) =>
      prev === 0 ? offerImages.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentImageIndex((prev) =>
      prev === offerImages.length - 1 ? 0 : prev + 1
    );
  };

  const handleBookAppointment = () => {
    window.open('https://2026.geteasysoftware.com/raj_cannine/qr/index.php?branch_id=UzN4eE9JUEUzaUltOERvTTJKVVNGUT09', '_blank');
  };

  return (
    <>
      {/* Book Appointment Floating Bubble */}
      <button
        onClick={handleBookAppointment}
        className="fixed bottom-32 right-6 z-50 bg-blue-500 hover:bg-blue-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 group w-16 h-16 flex items-center justify-center"
        aria-label="Book Appointment"
      >
        <Calendar className="w-8 h-8" />
        {/* Glow effect */}
        <div className="absolute inset-0 rounded-full bg-blue-400 opacity-0 group-hover:opacity-30 blur-xl transition-opacity duration-300"></div>
      </button>

      {/* Floating Offers Bubble Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-6 right-6 z-50 bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 group w-16 h-16 flex items-center justify-center"
        aria-label="View Offers"
      >
        <Tag className="w-8 h-8 animate-pulse" />
        {/* Glow effect */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-pink-400 to-purple-500 opacity-0 group-hover:opacity-30 blur-xl transition-opacity duration-300"></div>
      </button>

      {/* Popup Dialog */}
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="max-w-3xl p-0 overflow-hidden">
          <DialogHeader className="p-6 pb-4">
            <DialogTitle className="text-2xl font-bold text-center bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
              🎉 Special Offers 🎉
            </DialogTitle>
          </DialogHeader>

          {/* Image Display with Navigation */}
          <div className="relative px-6 pb-6">
            <div className="relative aspect-video bg-gray-100 rounded-lg overflow-hidden">
              <img
                src={offerImages[currentImageIndex].src}
                alt={offerImages[currentImageIndex].alt}
                className="w-full h-full object-contain"
              />

              {/* Navigation Buttons */}
              <Button
                onClick={handlePrevious}
                variant="secondary"
                size="icon"
                className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full shadow-lg bg-white/90 hover:bg-white"
              >
                <ChevronLeft className="w-6 h-6" />
              </Button>

              <Button
                onClick={handleNext}
                variant="secondary"
                size="icon"
                className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full shadow-lg bg-white/90 hover:bg-white"
              >
                <ChevronRight className="w-6 h-6" />
              </Button>

              {/* Image Counter */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/70 text-white px-4 py-2 rounded-full text-sm font-medium">
                {currentImageIndex + 1} / {offerImages.length}
              </div>
            </div>

            {/* Dots Indicator */}
            <div className="flex justify-center gap-2 mt-4">
              {offerImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentImageIndex(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    index === currentImageIndex
                      ? "bg-purple-600 w-8"
                      : "bg-gray-300 hover:bg-gray-400"
                  }`}
                  aria-label={`Go to image ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default OffersPopup;
